<template>
  <section class="section">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-6">

        </div>
        <div class="col-xs-12 col-sm-6">
          <div class="pull-right">
            <router-link to="/comboform" class="btn btn-fill">Nuevo combo</router-link>
          </div>
        </div>
      </div>
      <div class="row">
        <table class="table">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="combo in combos">
              <td>{{combo.nombre}}</td>
              <td>
                <ul class="table-actions smart-form">
                  <li>
                    <router-link :to="`/comboform/edit/${combo._id}`" class="btn btn-xs btn-ghost" type="button">
                      <i class="fa fa-actions fa-edit"></i>
                    </router-link>
                    <a href="" @click.prevent="eliminarCombo(combo._id)" class="btn btn-xs btn-ghost">
                      <i class="fa fa-actions fa-remove"></i>
                    </a>
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>
<script>
  export default {
    data () {
      return {
        combos: []
      }
    },
    mounted () {
      const me = this
      me.$http.get('/api/admin/combos').then(({body}) => {
        me.combos = body.combos
      }, (err) => {
        console.error(err)
      })
    },
    methods: {
      eliminarCombo (id) {
        const me = this
        me.$http.get('/api/admin/estaasignadocombo', {
          params: {
            id: id
          }
        }).then(({body}) => {
          console.log(body)
        }, (err) => {
          console.error(err)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ListaCombos.vue?47b49e80